// For click-only elements that must keep their markup (and styling) but work like a button from the keyboard.
export const asButton = (onActivate) => ({
    role: 'button',
    tabIndex: 0,
    onClick: (e) => {
        // A mouse click must not leave focus behind: the global a:focus colour would show where it never did before.
        if (e.detail > 0) {
            e.currentTarget.blur();
        }
        onActivate(e);
    },
    onKeyDown: (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onActivate(e);
        }
    },
});
